import React, { useContext } from "react";
import { Reactive, useSignalValue } from "./signal";
import { truthOrFail } from "./helpers";

export interface LocationContextValue {
  href: string;
  protocol: string;
  host: string;
  port: string;
  hostname: string;
  pathname: string;
  search: string;
  hash: string;
  origin: string;
  replace: (url: string) => void;
  assign: (url: string) => void;
}

export const LocationContext =
  React.createContext<Reactive<LocationContextValue> | null>(null);

export const useLocation = (): LocationContextValue =>
  useSignalValue(
    truthOrFail(useContext(LocationContext), "Missing LocationContext"),
  );
